module.exports = __webpack_public_path__ + "static/media/infra.683ff537.png";